/**
 * @file automatically generated from MApp.Endpoints.MapServiceContentController
 */ 

import { MetadataClient } from '../metadataClient';
import { ISaveMapService, IMapServiceListItem, IMapService, IPostSaveDataset, IValidationResult, IMapServiceUrlListItem, IMapServiceDepthCalculationData } from '../models';
import { GeoServiceType } from '../enums/Core';

export class MapServiceContentClient extends MetadataClient {

    public static saveMapService(mapService: ISaveMapService) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/mapservices`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(mapService)
			})
        );
    }

    public static replaceMapService(id: string, mapService: ISaveMapService) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/mapservices/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(mapService)
			})
        );
    }

    public static reorder(id: string, datasetIds: string[]) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/mapservices/${encodeURIComponent(id)}/reorder`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(datasetIds)
			})
        );
    }

    public static getMapServices() {
        return MetadataClient.ajax<IMapServiceListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/mapservices`)
        );
    }

    public static getMapService(id: string) {
        return MetadataClient.ajax<IMapService>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/mapservices/${encodeURIComponent(id)}`)
        );
    }

    public static deleteMapService(id: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/mapservices/${encodeURIComponent(id)}`, {
				method: 'DELETE'
			})
        );
    }

    public static saveDataset(serviceId: string, dataset: IPostSaveDataset) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/mapservices/datasets/${encodeURIComponent(serviceId)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(dataset)
			})
        );
    }

    public static deleteDataset(id: string, datasetId: string) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/mapservices/${encodeURIComponent(id)}/datasets/${encodeURIComponent(datasetId)}`, {
				method: 'DELETE'
			})
        );
    }

    public static isValidMapService(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/mapservices/isvalid?name=${encodeURIComponent(name)}`)
        );
    }

    public static getMapServiceUrls(serviceType: GeoServiceType) {
        return MetadataClient.ajax<IMapServiceUrlListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/mapservices/urls/${serviceType}`)
        );
    }

    public static calculateDepth(data: IMapServiceDepthCalculationData) {
        return MetadataClient.ajax<number>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/mapservices/calculateDepth`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(data)
			})
        );
    }

    public static getWmtsMapServices() {
        return MetadataClient.ajax<IMapServiceListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/mapservices/wmts`)
        );
    }
}
